import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, filter, switchMap, take} from 'rxjs/operators';
import {UNAUTHORISED_401} from '../constants/statuses.constants';
import {Router} from '@angular/router';
import {JWT_TOKEN_REQUIRED_PATHS} from '../constants/legacy.constants';
import {HttpLegacyService} from '../http/http-legacy.service';
import {LegacyAuthService, REMOVE_BEARER} from '../services/authentication/legacy-auth.service';
import {WindowService} from '../services/window.service';

@Injectable()
export class NotLoggedInInterceptor implements HttpInterceptor {

  private tokenRefreshInProgress = false;
  private refreshTokenSubject = new BehaviorSubject<unknown>(null);
  private readonly AUTH_REFRESH_ENDPOINT = 'v2/auth/refresh';

  private readonly HEADER_NAME = 'authorization';

  constructor(private route: Router,
              private legacy: HttpLegacyService,
              private authLegacy: LegacyAuthService,
              private window: WindowService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(catchError((error: HttpErrorResponse) => {

        if (error && error.status) {
          if (error.status === UNAUTHORISED_401) {

            if (this.checkLegacyUrl(request.url)) {

              if (!this.tokenRefreshInProgress
                && error.url.indexOf(this.AUTH_REFRESH_ENDPOINT) === -1) {
                this.tokenRefreshInProgress = true;
                return this.legacy.post(this.AUTH_REFRESH_ENDPOINT, {})
                  .pipe(catchError((tokenError) => {
                    this.logout();
                    return throwError(tokenError);
                  }), switchMap((data: { data: string }) => {
                    const token = data.data;
                    this.authLegacy.setToken(token);
                    this.tokenRefreshInProgress = false;
                    this.refreshTokenSubject.next(token);
                    return next.handle(this.addJwtToken(request, token));
                  }));
              } else if (error.url.indexOf(this.AUTH_REFRESH_ENDPOINT) !== -1) {
                this.logout();
              } else {
                return this.refreshTokenSubject.pipe(
                  filter(token => token != null),
                  take(1),
                  switchMap(jwt => {
                    return next.handle(this.addJwtToken(request, jwt));
                  }));
              }

            } else {
              this.logout();
            }
          }
        }

        return throwError(error);
      }));
  }

  private addJwtToken(request, token): HttpRequest<unknown> {
    return request.clone({headers: request.headers.set(this.HEADER_NAME, REMOVE_BEARER + token)});
  }

  private checkLegacyUrl(url): boolean {
    let legacy = false;
    JWT_TOKEN_REQUIRED_PATHS.forEach((validPath) => {
      if (url.indexOf(validPath) !== -1) {
        legacy = true;
      }
    });
    return legacy;
  }

  private logout(): void {
    this.route.navigate(['/logout'], {queryParams: {redirect: this.window.currentUrl()}});
  }
}
